import React from "react";

import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";

export const UserMembership = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" fontWeight={500}>
          Membership
        </Typography>
      </Grid>
    </Grid>
  );
};
